module.exports = __webpack_public_path__ + "images/emoji/fork_and_knife.bfbdee95131ff0e5c8f2.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fork_and_knife.png
// module id = iIJe
// module chunks = 13